<template>
  <div class="button-group" :class="computedClass">
    <slot />
  </div>
</template>

<script setup lang="ts">
interface Props {
  variant?: 'secondary' | 'primary' | 'light'
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'secondary',
})

const computedClass = computed(() => {
  return {
    [`button-group--variant-${props.variant}`]: true,
  }
})
</script>

<style lang="scss" scoped>
.button-group {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: var(--radius-sm);
  width: var(--button-group-width, auto);

  > *:not(div) {
    margin-left: rem(-4px);
    margin-right: rem(-4px);

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  &--variant {
    &-secondary {
      background-color: var(--color-surface-placeholder-600);
    }

    &-primary {
      background-color: var(--color-surface-primary);
    }

    &-light {
      background-color: var(--color-surface-bg);
    }
  }
}
</style>
